export const setReserveWithGoogleToken = async (rwg_token?: string) => {
  if (rwg_token) {
    document.cookie = `_rwg_token=${rwg_token}; max-age=2592000; domain=${window.location.host};`;
  }
};
